import {ErrorHandler, Injectable} from '@angular/core';
import {LoggingService} from '../shared/services/logging.service';
import {TorchTokenService} from '../../@backend/modules';

@Injectable({
  providedIn: 'root'
})
export class GlobalErrorHandler implements ErrorHandler {
  constructor(private logger: LoggingService,
              private tokenService: TorchTokenService) {
  }

  handleError(error: Error) {

    const chunkFailedMessage = /Loading chunk [\d]+ failed/;
    const badSessionMessage = /interaction_in_progress/;
    const badLoginMessage = /interaction_required/;

    if (chunkFailedMessage.test(error.message)) {
      window.location.reload();
      return;
    }

    if (badSessionMessage.test(error.message)) {
      this.logger.log('Bad Session!');
    }

    if (badLoginMessage.test(error.message)) {
      this.logger.log('Bad Login!');
      this.tokenService.redirectLogin().subscribe(() => this.logger.log('Redirected from login'));
    }

    this.logger.error('GlobalErrorHandler', error);
  }
}
